jQuery(document).ready(function ($) {
	if ($("body").hasClass("post-type-archive-news")) {
		const postGrid = document.getElementById("post_grid");

		const allCategories = $("#categories .category input").toArray();
		const allYears = $("#years .year input").toArray();

		const selectedFilterClassName = "active";

		let data = {
			action: "archive_filter_news",
			post_type: "news",
			category: [],
			year: [],
			page: 1,
			search: "",
		};

		$("#reset_filters").on("click keypress", (e) => {
			if (e.type == "click" || e.key == "Enter") {
				const categoryLabels = [
					...document.querySelectorAll("#categories label"),
				];
				const yearLabels = [...document.querySelectorAll("#years label")];

				data.category = [];
				data.year = [];
				data.search = "";
				data.page = 1;

				removeActiveFilters(categoryLabels, "all_categories");
				removeActiveFilters(yearLabels, "all_years");

				$("#search_news").val("");

				if ($("#search").find(".has-value").length) {
					$(".has-value").removeClass("has-value");
				}

				sendAjaxRequest(data, () => {
					updatePagination(1, $(".pagination_custom.last").data("page"), 0, 2);
				});
			}
		});

		$(
			".pagination_wrapper .arrow-button, .pagination_wrapper .pagination_custom"
		).on("click keypress", (e) => {
			if (e.type === "click" || e.key === "Enter") {
				const { newPage, prevPage, nextPage } = getNewPageNumbers(e);

				data.page = newPage;

				sendAjaxRequest(data, () => {
					updatePagination(
						newPage,
						$(".pagination_custom.last").data("page"),
						prevPage,
						nextPage
					);
				});
			}
		});

		$(".category label, .year label").on("click keypress", (e) => {
			const updateArray = (array, excludedId) => {
				let temporaryArray = [];

				array.forEach((arrayItem) => {
					const item = $(arrayItem);
					if (
						item.siblings("label").hasClass(selectedFilterClassName) &&
						item.attr("id") !== excludedId
					) {
						temporaryArray.push(item.attr("id"));
					}
				});

				return temporaryArray;
			};

			if (e.type == "click" || e.key == "Enter") {
				selectCategoryOrYear(e);
				const containerId = $(e.target).closest(".filter-box").attr("id");

				if (containerId === "categories") {
					data.category = updateArray(allCategories, "all_categories");
				} else if (containerId === "years") {
					data.year = updateArray(allYears, "all_years");
				}
				data.page = 1;
				sendAjaxRequest(data, () =>
					updatePagination(1, $(".pagination_custom.last").data("page"), 0, 2)
				);
			}
		});

		// hide see more years text and show the hidden years
		$("#see_more_years").on("click keypress", (e) => {
			if (e.type == "click" || e.key == "Enter") {
				$(".year.hide").removeClass("hide");
				$("#see_more_years").hide();
			}
		});

		$("#filter_button").on("click", () => {
			$(".filter_wrapper").toggleClass("hide");
		});

		// $("#search_news").on(
		// 	"keyup",
		// 	debounce((e) => search(e) )
		// 	console.log("#search_news keyup")
		// );
		$("#search_news").on(
			"keyup",
			debounce((e) => {
				search(e);
				// console.log("#search_news keyup");
			})
		);

		/* Searchwp TRY */
		// Add an event listener to the SearchWP form input
		$("#search2 .swp-input").on(
			"input",
			debounce((e) => {
				search(e);
				console.log("#search2 .swp-input input");
			})
		);

		function search(e) {
			data.search = $(e.target).val();
			sendAjaxRequest(data);
			// console.log("function search(e)");
			// console.log(data);
		}

		function removeActiveFilters(array, elementForAttr) {
			// console.log("function removeActiveFilters(array, elementForAttr)");

			array.forEach((item) => {
				const isAllInput = $(item).attr("for") === elementForAttr;

				$(item).toggleClass(selectedFilterClassName, isAllInput);
				$(item).siblings("input").attr("checked", isAllInput);
			});
		}

		function selectCategoryOrYear(event) {
			// console.log("function selectCategoryOrYear(event)");

			const selectedInputIsCategoryType = $(event.target)
				.parent()
				.hasClass("category");
			let filterTypeClass = selectedInputIsCategoryType ? ".category" : ".year";
			let allFiltersOfTypeInputId = selectedInputIsCategoryType
				? "all_categories"
				: "all_years";

			const getActiveFilters = () => {
				return [
					...document.querySelectorAll(
						`${filterTypeClass} label:not([for=${allFiltersOfTypeInputId}]).${selectedFilterClassName}`
					),
				];
			};

			// if label[for=all_categories] or label[for=all_years] were clicked
			if (
				$(event.target).attr("for").toLowerCase() ==
				`${allFiltersOfTypeInputId.toLowerCase()}`
			) {
				if (!$(event.target).hasClass(selectedFilterClassName)) {
					getActiveFilters().forEach((filter) => {
						$(filter).removeClass(selectedFilterClassName);
						$(filter)
							.siblings("input")
							.attr({ checked: false, checked: false });
					});

					$(`#${allFiltersOfTypeInputId}`).attr({
						disabled: true,
						checked: true,
					});
					$(event.target).toggleClass(selectedFilterClassName);
				}
			} else {
				// if year clicked - else will run every time as all years input is hidden

				const toggleAllFiltersOfTypeInput = (checkedAndDisabledBool) => {
					$(`label[for=${allFiltersOfTypeInputId}]`).toggleClass(
						selectedFilterClassName,
						checkedAndDisabledBool
					);

					$(`#${allFiltersOfTypeInputId}`).attr({
						disabled: checkedAndDisabledBool,
						checked: checkedAndDisabledBool,
					});
				};

				$(event.target)
					.siblings("input")
					.attr("checked", !$(event.target).siblings("input").attr("checked"));
				$(event.target).toggleClass(selectedFilterClassName);

				// check or uncheck #all_categories or #all_years

				toggleAllFiltersOfTypeInput(getActiveFilters().length === 0);
			}
		}

		function sendAjaxRequest(data, callback) {
			// console.log("function sendAjaxRequest(data, callback)");

			$.ajax({
				url: ajax_url,
				type: "post",
				dataType: "json",
				data: data,

				success: ({ blog_data, pages, show_pagination } = res) => {
					if (blog_data) {
						$(".pagination_custom.last").removeClass("last");
						$(`.pagination_custom[data-page='${pages}']`).addClass("last");

						postGrid.innerHTML = "";

						for (post of blog_data) {
							postGrid.innerHTML += post_html(post);
						}
					}

					toggleShowResults(postGrid, blog_data ? "show" : "hide");

					$("#pagination").toggle(show_pagination);

					scroll($("#post_grid"), -50);

					if (callback) {
						callback();
					}
				},
				error: function (xhr, status, error) {
					console.error(xhr.responseText);
					toggleShowResults(postGrid, "hide");
				},
			});
		}

		function post_html(data) {
			// console.log("function post_html(data)");

			const dateFormatted = new Date(data.date);
			const fullDateString = `${
				MONTHS[dateFormatted.getMonth()]
			} ${dateFormatted.getDate()}, ${dateFormatted.getFullYear()}`;

			return `<a href="${data.permalink}" class="news-article col-lg-4 is-link">
						<div class="post-container">
							<div class="thumbnail">
								<div class="category">${data.category}</div>
								<img width="1707" height="2560" src="${data.thumbnail}" class="attachment-full size-full wp-post-image" alt="" decoding="async" loading="lazy">
							</div>
							<div class="info">
								<p class="date">${fullDateString}</p>
								<h3 class="text-clamp text-clamp-2 title">${data.title}</h3>
								<p class="excerpt text-clamp text-clamp-3">${data.excerpt}</p>
								<div class="link"><span>Read more</span><img src="${homeUrl}/wp-content/themes/Endless23/assets/Icons/Right-Arrow-Icon-Orange.svg" alt=""></div>
							</div>
						</div>
					</a>`;
		}
	}
});
